import { redirect } from "react-router-dom"

import { getRouterContext, resolveTelegramRouteContext } from "@/shared/router"

import type { MiddlewareFunction } from "react-router-dom"

export const contextReadyMiddleware: MiddlewareFunction = async (_args, next) => {
  await getRouterContext()
  return next()
}

export const protectedMiddleware = async () => {
  const { chatId, shareToken } = await resolveTelegramRouteContext(undefined, "RouterMiddleware")

  if (chatId === null && shareToken === null) {
    return redirect("/dashboard")
  }

  return null
}
